import React from 'react'

export const Insurance = () => {
  return (
    <div>Insurance</div>
  )
}
